// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemsLineCutter_container__18jle","overflowCount":"ItemsLineCutter_overflowCount__3j6b7"};